import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { IonItem, IonIcon, IonToast } from "@ionic/react";
import { clipboardOutline } from "ionicons/icons";
import styled from "styled-components";

import strings from "../../../../res/strings";
import "./index.css";

const Container = styled.div`
  padding-top: 8px;
`;
const Label = styled.div`
  font-size: 0.9em;
  color: #3880ff;
  font-weight: bold;
`;
const Component = styled(IonItem)``;
const Value = styled.input`
  font-size: 0.9em;
  background: #f1f1f1;
  width: 90%;
  height: 31px;
  border-right: none;
`;
const ClipboardButtonContainer = styled.div`
  width: 10%;
  justify-content: center;
  background: #3880ff;
  display: flex;
  height: 31px;
  width: 31px;
  padding-top: 4px;
`;
const ClipboardButton = styled(IonIcon)`
  color: #ffffff;
  font-size: 1.2em;
`;

const CopyableValue = (props) => {
  const [copied, setCopied] = useState(false);

  return (
    <Container>
      <Label>{props.label}</Label>
      <Component lines="none" class="copyable-value-container">
        <Value readonly value={props.value} onChange={() => {}} />
        <CopyToClipboard
          text={props.value}
          onCopy={() => {
            setCopied(true);
          }}
        >
          <ClipboardButtonContainer>
            <ClipboardButton icon={clipboardOutline} />
          </ClipboardButtonContainer>
        </CopyToClipboard>
      </Component>
      <IonToast
        isOpen={copied}
        message={strings.lib_common_state_success_copy_clipboard}
        duration={1000 * 3}
        onDidDismiss={() => {
          setCopied(false);
        }}
      />
    </Container>
  );
};

export default CopyableValue;
